import React, { useState, useEffect, useRef } from "react";
import "../styles/About.css";
import {
  FaLeaf,
  FaAward,
  FaUsers,
  FaIndustry,
  FaShieldAlt,
  FaChartLine,
  FaPlay,
  FaGlobe,
  FaTools,
  FaTruck,
} from "react-icons/fa";
import bannerImage from "../assets/carousel-1.jpg";
import banner from "../assets/aboutus.jpg";

const About = ({ showImages = true }) => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const playVideo = () => {
    setIsVideoPlaying(true);
  };

  // Scroll animation observer
  const useScrollAnimation = () => {
    useEffect(() => {
      const elements = document.querySelectorAll('.animate-on-scroll');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animated');
          }
        });
      }, { threshold: 0.1 });

      elements.forEach(el => observer.observe(el));

      return () => observer.disconnect();
    }, []);
  };

  useScrollAnimation();

  return (
    <div className="about-page">
      {/* Hero Section with Background Image */}
      {showImages && (
        <section
          className="hero-section animate-on-scroll"
          style={{
            width: "100%",
            backgroundImage: `url(${banner})`,
          }}
        >
          {/* <div className="hero-overlay">
            <div className="hero-content">
              <h1 className="hero-main-title fade-in-up">About Us</h1>
              <p className="hero-subtitle fade-in-up delay-1">Pixeled Industries</p>
            </div>
          </div> */}
        </section>
      )}

      {/* Main Content Container - Left Aligned */}
      <div className="about-container-left">

        {/* Video and Text Section - Left Aligned */}
        <section className="video-text-section-left animate-on-scroll">
          <div className="video-text-container-left">
            {/* Left Column - Video Thumbnail/Player */}
            <div className="video-column-left">
              {!isVideoPlaying ? (
                <div className="video-thumbnail-left" onClick={playVideo}>
                  <img
                    src={bannerImage}
                    alt="Pixeled Manufacturing Process Video Thumbnail"
                    className="thumbnail-image-left"
                  />
                  <div className="play-button-overlay-left">
                    <div className="play-button-left">
                      <FaPlay />
                    </div>
                  </div>
                  <div className="video-caption-left">PIXELED</div>
                </div>
              ) : (
                <div className="video-player-left">
                  <iframe
                    src="https://pixeltools.in/test/products/FIND.mp4"
                    title="Pixeled Manufacturing Process Video"
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                    className="video-iframe-left"
                  ></iframe>
                </div>
              )}
            </div>

            {/* Right Column - Text Content - Left Aligned */}
            <div className="text-column-left">
              <div className="vision-mission-block">
                <h2 className="section-title-left">Vision</h2>
                <div className="content-box-left">
                  <p className="content-text-left">
                    To establish a legacy of industrial excellence by building a thorough, unshakeable foundation in manufacturing; evolving from a specialist in armatures to a diversified global leader that scales without compromising on the integrity of its core operations.
                  </p>
                </div>
              </div>

              <div className="vision-mission-block1">
                <h2 className="section-title-left">Mission</h2>
                <div className="content-box-left">
                  <p className="content-text-left">
                    Our mission is to localize global engineering standards for the Indian market through precision-led manufacturing and strategic trade. We are committed to the continuous improvement of our legacy processes while expanding into a wider offering, ensuring our partners receive world-class quality, innovative technology, and absolute reliability in every component we deliver.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* About Pixel Section - Left Aligned */}
        <section className="about-pixel-section-left animate-on-scroll">
          <div className="about-pixel-content-left">
            {/* <div className="section-tag">Who We Are</div> */}
            {/* <h2 className="section-title-left">About Pixeled</h2> */}
            <h2 className="section-title-left">Who We Are</h2>

            <div className="content-box-left">
              <p className="content-text-left">
                Founded in <span className="highlight">June 2022</span> and headquartered in <span className="highlight">Sultanpur</span>, Pixeled was established with a singular focus: to redefine the standards of industrial manufacturing and supply chain reliability. What began as a specialized operation dedicated to the manufacturing of high-performance armatures has rapidly evolved into a multifaceted industrial powerhouse.
              </p>
            </div>
          </div>
        </section>

        {/* Evolution Section - Left Aligned */}
        <section className="evolution-section-left animate-on-scroll">
          <div className="evolution-content-left">
            {/* <div className="section-tag">Our Journey</div> */}
            <h2 className="section-title-left">Evolution & Strategic Expansion</h2>
            <div className="content-box-left">
              <p className="content-text-left">
                At Pixeled, we believe that growth should never come at the expense of quality; our expansion is a direct evolution of our existing technical strengths.
              </p>
              <p className="content-text-left">
                Our journey—marked by the launch of our <span className="highlight">Accessories Division in 2025</span> and new product categories in <span className="highlight">2026</span>—is driven by a commitment to never compromise quality for price. By maintaining a thorough operational base and an expanding global export-import network, Pixeled ensures that as we innovate for the future, we remain a rock-solid partner for the industries of today.
              </p>
            </div>
          </div>
        </section>

        {/* Global-Local Bridge Section - Left Aligned */}
        <section className="bridge-section-left animate-on-scroll">
          <div className="bridge-content-left">
            {/* <div className="section-tag">Our Advantage</div> */}
            <h2 className="section-title-left">The "Global-Local" Bridge</h2>
            <div className="content-box-left">
              <p className="content-text-left">
                Our long-term objective is to democratize high-end technology by integrating global quality standards directly into the Indian market through our localized manufacturing. By merging international engineering benchmarks with local accessibility, we ensure our partners receive world-class, innovative technology in every component we deliver.
              </p>
            </div>
          </div>
        </section>

        {/* Looking Ahead Section - Left Aligned */}
        <section className="looking-ahead-section-left animate-on-scroll">
          <div className="looking-ahead-content-left">
            {/* <div className="section-tag">Future Focus</div> */}
            <h2 className="section-title-left">Looking Ahead</h2>
            <div className="content-box-left">
              <p className="content-text-left">
                Consistent with our theme of foundational integrity, Pixeled is committed to the continuous development of new industrial solutions. We will continue to expand our offerings and pioneer new product categories, ensuring that as we manufacture the future, we never lose sight of the precision that built our past.
              </p>
            </div>
          </div>
        </section>

        {/* Core Values Section - Left Aligned with Cards */}
        <section className="values-section-left animate-on-scroll">
          {/* <div className="section-tag text-left-tag">Our Principles</div> */}
          <h2 className="section-title-left">Core Values</h2>
          <div className="values-grid-left">
            <div className="value-card-left hover-lift">
              <div className="value-icon-left">
                <FaAward />
              </div>
              <h3 className="value-title-left">Quality Over Commerciality</h3>
              <p className="value-description-left">
                We manufacture high-quality armatures, welding machines, resiflex blades, and power tool spare parts using premium materials and strict quality standards. Every product is designed for reliable performance, durability, and long-term value.
              </p>
            </div>

            <div className="value-card-left hover-lift">
              <div className="value-icon-left">
                <FaShieldAlt />
              </div>
              <h3 className="value-title-left">Foundational Stability</h3>
              <p className="value-description-left">
                Built on advanced manufacturing and precision engineering, our products deliver consistent quality and dependable performance for industrial applications, dealers, and service centers.
              </p>
            </div>

            <div className="value-card-left hover-lift">
              <div className="value-icon-left">
                <FaUsers />
              </div>
              <h3 className="value-title-left">Service Excellence</h3>
              <p className="value-description-left">
                From technical assistance to customer support, we are committed to delivering reliable solutions and building long-term relationships through quality products and trusted service.
              </p>
            </div>
          </div>
        </section>

        {/* Pixeled Ecosystem Section - Left Aligned */}
        <section className="ecosystem-section-left animate-on-scroll">
          {/* <div className="section-tag text-left-tag">Our Infrastructure</div> */}
          <h2 className="section-title-left">The Pixeled Ecosystem</h2>
          <div className="features-grid-left">
            <div className="feature-item-left hover-lift">
              <FaIndustry className="feature-icon-left" />
              <h3>Advanced Manufacturing</h3>
              <p>Modern manufacturing facilities equipped to produce high-quality armatures, power tool components, welding machines, and industrial products with consistent quality.</p>
            </div>

            <div className="feature-item-left hover-lift">
              <FaGlobe className="feature-icon-left" />
              <h3>Strategic Trading & Exports</h3>
              <p>Supporting dealers, distributors, and industrial partners with reliable products and efficient supply across domestic and international markets.</p>
            </div>

            <div className="feature-item-left hover-lift">
              <FaTools className="feature-icon-left" />
              <h3>Strategic Diversification</h3>
              <p>Expanding our product range with innovative solutions including welding machines, resiflex blades, and power tool spare parts.</p>
            </div>

            <div className="feature-item-left hover-lift">
              <FaTruck className="feature-icon-left" />
              <h3>Integrated Supply Chain</h3>
              <p>A strong supply chain network ensures efficient inventory management, product availability, and timely delivery across India.</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;